import { AnyRouter, NavigateOptions, RegisteredRouter, RoutePaths, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * This mimics the Navigate component from tanstack router. It uses `replace` by default and supports chaining.
 * The original implementation doesn't use effect dependencies and cannot be used for consecutive redirects.
 */
export function Redirect<
    TRouter extends AnyRouter = RegisteredRouter,
    TFrom extends RoutePaths<TRouter['routeTree']> | string = string,
    TTo extends string | undefined = undefined,
    TMaskFrom extends RoutePaths<TRouter['routeTree']> | string = TFrom,
    TMaskTo extends string = '',
>(props: NavigateOptions<TRouter, TFrom, TTo, TMaskFrom, TMaskTo>): null {
    const navigate = useNavigate();

    useEffect(() => {
        const timeout = window.setTimeout(() => {
            void navigate({ replace: true, ...props });
        }, 0);

        return () => {
            window.clearTimeout(timeout);
        };
    }, [navigate, props]);

    return null;
}
